import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { FIND_FORM_BY_ID_USE_CASE, FIND_GROUPED_QUESTIONS_BY_SECTION_USE_CASE, FormRelease, GET_SECTION_SUMMARIES_USE_CASE, SectionSummaries, SectionSummary, FIND_FORM_RELEASE_BY_ID_USE_CASE, FIND_QUESTION_RELEASES_USE_CASE, QuestionReleases } from '@module/form';
import { UPDATE_SELECTED_SECTION } from '../root.action';
export var handleFindAllQuestionsUseCase = {
  name: FIND_GROUPED_QUESTIONS_BY_SECTION_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isLoadingQuestions: true
    });
  },
  success: function success(state, action) {
    var payload = action.payload;
    var output = payload;
    var sectionSummaries = output.sectionSummaries,
        questions = output.questions;
    return _objectSpread(_objectSpread({}, state), {}, {
      questions: questions,
      sectionSummaries: sectionSummaries,
      isLoadingQuestions: false
    });
  },
  error: function error(state, action) {
    var error = action.error;
    return _objectSpread(_objectSpread({}, state), {}, {
      error: error,
      isLoadingQuestions: false
    });
  }
};
export var handleFindSectionSummariesUseCase = {
  name: GET_SECTION_SUMMARIES_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isLoadSectionSummaries: true
    });
  },
  success: function success(state, action) {
    var payload = action.payload;
    var sectionSummaries = payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      sectionSummaries: sectionSummaries,
      isLoadSectionSummaries: false
    });
  },
  error: function error(state, action) {
    var error = action.error;
    return _objectSpread(_objectSpread({}, state), {}, {
      error: error,
      isLoadSectionSummaries: false
    });
  }
};
export var handleFindFormByIdUseCase = {
  name: FIND_FORM_BY_ID_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isLoadingForm: true
    });
  },
  success: function success(state, action) {
    var payload = action.payload;
    var form = payload;
    var defaultSelectedSectionIndex = 0;
    return _objectSpread(_objectSpread({}, state), {}, {
      form: form,
      selectedSection: form.sections[defaultSelectedSectionIndex],
      selectedSectionIndex: defaultSelectedSectionIndex,
      isLoadingForm: false
    });
  },
  error: function error(state, action) {
    var error = action.error;
    return _objectSpread(_objectSpread({}, state), {}, {
      error: error,
      isLoadingForm: false
    });
  },
  reset: function reset(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      form: null,
      selectedSection: null
    });
  }
};
export var handleChangeSelectedSection = {
  name: UPDATE_SELECTED_SECTION,
  executing: function executing(state, action) {
    var _state$sectionSummari;

    var payload = action.payload;
    return _objectSpread(_objectSpread({}, state), {}, {
      selectedSection: payload.selectedSection,
      selectedSectionIndex: (_state$sectionSummari = state.sectionSummaries) === null || _state$sectionSummari === void 0 ? void 0 : _state$sectionSummari.findIndex(function (s) {
        var _payload$selectedSect;

        return s.id.toString() === ((_payload$selectedSect = payload.selectedSection) === null || _payload$selectedSect === void 0 ? void 0 : _payload$selectedSect.id.toString());
      })
    });
  }
};
export var handleFindFormReleaseByIdUseCase = {
  name: FIND_FORM_RELEASE_BY_ID_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isLoadingForm: true
    });
  },
  success: function success(state, action) {
    var payload = action.payload;
    var formRelease = payload;
    var defaultSelectedSectionIndex = 0;
    return _objectSpread(_objectSpread({}, state), {}, {
      form: formRelease,
      selectedSection: formRelease.sections[defaultSelectedSectionIndex],
      selectedSectionIndex: defaultSelectedSectionIndex,
      isLoadingForm: false
    });
  },
  error: function error(state, action) {
    var error = action.error;
    return _objectSpread(_objectSpread({}, state), {}, {
      error: error,
      isLoadingForm: false
    });
  }
};
export var handleFindQuestionReleasesUseCase = {
  name: FIND_QUESTION_RELEASES_USE_CASE,
  executing: function executing(state) {
    return _objectSpread(_objectSpread({}, state), {}, {
      isLoadingQuestions: true
    });
  },
  success: function success(state, action) {
    var _state$sectionSummari2;

    var payload = action.payload;
    var questions = payload;
    var form = state.form;
    var sections = (_state$sectionSummari2 = state.sectionSummaries) !== null && _state$sectionSummari2 !== void 0 ? _state$sectionSummari2 : [];

    if (!sections.length && form) {
      sections = form instanceof FormRelease ? form.sections : SectionSummaries.toSectionSummaries(form.sections);
    }

    var sortedQuestions = QuestionReleases.sortQuestionsWithIndexBySectionsOrder(questions, sections);
    var sectionSummaries = sections.map(function (section) {
      return SectionSummary.cloneFromSectionAndQuestions(section, sortedQuestions);
    });
    return _objectSpread(_objectSpread({}, state), {}, {
      questions: sortedQuestions,
      sectionSummaries: sectionSummaries,
      isLoadingQuestions: false
    });
  },
  error: function error(state, action) {
    var error = action.error;
    return _objectSpread(_objectSpread({}, state), {}, {
      error: error,
      isLoadingQuestions: false
    });
  }
};
export var formPreviewHandlers = [handleFindFormByIdUseCase, handleFindAllQuestionsUseCase, handleFindSectionSummariesUseCase, handleChangeSelectedSection, handleFindFormReleaseByIdUseCase, handleFindQuestionReleasesUseCase];